import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const isLoggingOutState = atom(false);

export const jwtTokenState = atomWithStorage<string | null>(
  'jwtTokenState',
  null,
  undefined,
  { getOnInit: true },
);
